export const ChangePasswordTypes = {
  CHANGE_PASSWORD_RESET: '[changePassword]CHANGE_PASSWORD_RESET',
  CHANGE_PASSWORD_REQUEST: '[changePassword]CHANGE_PASSWORD_REQUEST',
  CHANGE_PASSWORD_SUCCESS: '[changePassword]CHANGE_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_FAILURE: '[changePassword]CHANGE_PASSWORD_FAILURE',
};
